export {
	evaluateCoupons,
	getRecentlyViewed,
	getRecommendation,
	getPopularProducts,
	getTrendingProducts,
	guestUserId,
	mergeUserSession,
	recomApi,
	recordUserEvents,
	resolveRecomIdentity,
	submitUserQuiz,
	updateUserProfile,
} from '@/data/recom/client';
export type {
	EvaluateCouponsOptions,
	GetRecentlyViewedOptions,
	GetRecommendationOptions,
	GetPopularProductsOptions,
	GetTrendingProductsOptions,
	MergeUserSessionOptions,
	RecomCallOptions,
	RecordUserEventsOptions,
	SubmitUserQuizOptions,
	UpdateUserProfileOptions,
} from '@/data/recom/client';

export {
	RECOM_CART_PARTNUMBERS_MAX,
	RECOM_ERROR_CODE,
	RECOM_PROXY_BASE_PATH,
	RECOM_USER_DATA_KEY,
} from '@/data/recom/constants';
export type { RecomErrorCode } from '@/data/recom/constants';

export { createRecomApiError, isRecomApiError, toRecomApiError } from '@/data/recom/errors';
export type { RecomApiError } from '@/data/recom/errors';

export { allowedRecomQuery, isAllowedRecomRoute, recomPaths } from '@/data/recom/endpoints';

export * from '@/data/recom/types';
